import axios from 'axios';

const instance =  axios.create({
    baseURL: 'https://boiling-inlet-61601.herokuapp.com',
});

export default instance;